export const CommentTemplateValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.vc_Title.trim()) {
      errors.vc_Title = 'This Field is required';
    } 
    if (!formData.vc_ServiceCode.trim()) {
        errors.vc_ServiceCode = 'This Field is required';
      } 
      if (!formData.vc_Comment.trim()) {
        errors.vc_Comment = 'This Field is required';
      } 
  
    return errors;
  };
  
 